// extracted by mini-css-extract-plugin
export default {"wrapper":"NFT_wrapper__yPIEd","image":"NFT_image__vPZqk","title":"NFT_title__nWQ+X","price":"NFT_price__NNVoS","buttons":"NFT_buttons__+Jj48"};